import React, { useRef, useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import Marker from "../Shared/img/animated-target.svg";
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import Popover from '@mui/material/Popover';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";


export const Component = (props) => {
    const localizationCtx = useContext(LocalizationContext);
    const headerBarTitle = localizationCtx.localizationData.headerBarTitle + props.deckName;
    const normalImageStyle = (props.isProfile === true ? "h-layout-profile" : "h-layout") + " imageComponent";
    const highlightedImageStyle = (props.isProfile === true ? "h-layout-profile" : "h-layout") + " imageComponent selectedComponent";

    const myComponent = props.element;
    const indexImage = myComponent.idComponent;
    const [imageStyle, setImageStyle] = useState(normalImageStyle);
    const [anchorOriginVertical, setAnchorOriginVertical] = useState('bottom');
    const [anchorOriginHorizontal, setAnchorOriginHorizontal] = useState('center');
    const [transOriginVertical, setTransOriginVertical] = useState('top');
    const [transOriginHorizontal, setTransOriginHorizontal] = useState('center');
    const isMobile = useMediaQuery('(max-width:920px)');

    const [storedScrollY, setStoredScrollY] = useState(0);

    useEffect(() => {
        if (isMobile) {

            const myPositions = myComponent.popoverMobilePosition.split("/");
            if (myPositions.length === 4) {
                setAnchorOriginVertical(myPositions[0]);
                setAnchorOriginHorizontal(myPositions[1]);
                setTransOriginVertical(myPositions[2]);
                setTransOriginHorizontal(myPositions[3]);
            }

        } else {
            setAnchorOriginVertical('bottom');
            setAnchorOriginHorizontal('center');
            setTransOriginVertical('top');
            setTransOriginHorizontal('center');
        }

        if (props.element.markerPositionTop === "0" && props.element.markerPositionLeft === "0") {
            setIsVisibleMarker(false);
        }

    }, [isMobile]);


    const [myCustomizationName, setMyCustomizationName] = useState(headerBarTitle);
    const customizationCtx = useContext(CustomizationContext);

    const [myOptional, setMyOptional] = useState({
        idDeck: "",
        position: 0,
        idComponent: ""
    });

    const [currentImage, setCurrentImage] = useState(myComponent.urlImage);

    const [enableInteraction, setEnableInteraction] = useState(props.enableConfiguration);
    const [optionalLoaded, setOptionalLoaded] = useState(false);
    const [optionalList, setOptionaList] = useState([]);
    const [anchorElement, setAnchorElement] = useState(null);
    const [isVisibleMarker, setIsVisibleMarker] = useState(true);

    const handleCloseOptionalList = () => {
        setAnchorElement(null);
        setIsVisibleMarker(true);
        setCurrentImage(myComponent.urlImage);
        setImageStyle(normalImageStyle);
    };

    const open = Boolean(anchorElement);
    const idOptionalList = open ? 'simple-popover' : undefined;

    const ref = useRef(null);

    const handleComponentClick = (event) => {
        if (myComponent.isCustomizable && enableInteraction) {
            const componentImageRef = ref.current;

            setAnchorElement(componentImageRef);
            setIsVisibleMarker(false);
            setImageStyle(highlightedImageStyle);

            const userAgentString = navigator.userAgent;
            let chromeAgent = userAgentString.indexOf("Chrome") > -1; 
            let safariAgent = userAgentString.indexOf("Safari") > -1; 
            if ((chromeAgent) && (safariAgent)) safariAgent = false; 

            let deltaH = 300;
            let deltaOffsetY = 100;

            let h;
            let offsetY;


            if (!isMobile) {
                if (!safariAgent) {
                    h = componentImageRef.y + componentImageRef.height + deltaH;
                    if (h > window.screen.height) {
                        offsetY = Math.abs(h - window.screen.height) + deltaOffsetY;
                        window.scrollTo(0, window.scrollY + offsetY);
                    }

                } else {
                    h = componentImageRef.y + componentImageRef.height + deltaH - window.scrollY;
                    let delta = Math.abs(window.scrollY - componentImageRef.y);
                    if (delta > (deltaH + 50)) {
                        offsetY = Math.abs(delta - deltaH - 50) + deltaOffsetY;
                        window.scrollTo(0, window.scrollY + offsetY);
                    }
                }

                //console.log(h + ", " + window.screen.height + ", " + window.scrollY);
                //console.log(componentImageRef.y + ", " + componentImageRef.height + ", " + deltaH);
            }


            getOptionals();
        }
    }

    const handleOptionalClick = (idOptional) => {
        myOptional.idDeck = props.idDeck;
        myOptional.position = myComponent.position;
        myOptional.idComponent = idOptional;
        changeOptional(myOptional);
    }

    const handleChangeSlide = (swiper) => {
        let index = swiper.activeIndex;
        let myOptional = optionalList[index];
        setCurrentImage(myOptional.urlImage);
    };

    const changeOptional = async (changedData) => {
        const response = await fetch("/api/customization/changeoptional/" + myComponent.idLayoutOptional, {
            method: 'POST',
            body: JSON.stringify(changedData),
            headers: { 'Content-Type': 'application/json' }
        });

        setOptionalLoaded(false);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                props.feedbackCallback("config-success", localizationCtx.localizationData.alertUpdated, true);
                props.callBack(0, window.scrollY);
            } else {
                props.feedbackCallback("error", "Error changing optional", true);
            }
        } else {
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }
    }

    const getOptionals = async () => {

        const response = await fetch("/api/customization/getoptional/" + myComponent.idComponent + "/" + customizationCtx.customizationData.language);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                setOptionaList(data);
                setOptionalLoaded(true);
            } else {
                props.feedbackCallback("error", "Error loading optional data", true);
            }

        } else {
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }
    }

    return (
        <>
            {enableInteraction &&
                <div className="imgContainer">
                    <img src={currentImage} className={imageStyle} alt={myComponent.componentName} ref={ref} id={indexImage} />
                    {isVisibleMarker && myComponent.isCustomizable && <img className="imageMarker" src={Marker} style={{ top: myComponent.markerPositionTop, left: myComponent.markerPositionLeft }} onClick={() => handleComponentClick(myComponent.idComponent)} />}
                </div>
            }
            {!enableInteraction && <img src={currentImage} className={props.isProfile === true ? "h-layout-summary-profile" : "h-layout-summary"} alt={myComponent.componentName} />}
            <Popover
                id={idOptionalList}
                open={open}
                anchorEl={anchorElement}
                onClose={handleCloseOptionalList}
                anchorOrigin={{
                    vertical: anchorOriginVertical,
                    horizontal: anchorOriginHorizontal,
                }}
                transformOrigin={{
                    vertical: transOriginVertical,
                    horizontal: transOriginHorizontal,
                }}

            >
                <div className="box-optional-container">
                    <div className="row">
                        <div className="col-12 bkg-deep-ocean text-center d-flex align-items-center">
                            <a className="close-optional" onClick={handleCloseOptionalList}><CloseRoundedIcon style={{ color: 'white' }} /></a>
                            <Typography className="text-title-optional">{myCustomizationName}</Typography>
                        </div>
                    </div>
                    <div className="row">
                        <div className="container-fluid bkg-white">
                            <div className="row">
                                <div className="col-12">
                                    <Swiper
                                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                                        navigation
                                        pagination={{ type: "fraction" }}
                                        onSlideChange={(swiper) => handleChangeSlide(swiper)}
                                    >
                                        {optionalList.map((myOptional, i) => (
                                            <SwiperSlide key={i}>
                                                <div className="row box-optional d-flex align-items-center py-0">
                                                    <div className="col-4 col-md-4 col-lg-5 text-center">
                                                        {/*<Tooltip*/}
                                                        {/*    TransitionComponent={Fade}*/}
                                                        {/*    TransitionProps={{ timeout: 600 }}*/}
                                                        {/*    title="Apply"*/}
                                                        {/*    followCursor*/}
                                                        {/*>*/}
                                                        {/*    <img key={i} src={myOptional.urlThumb} className="w-optional" alt={myOptional.componentName} onClick={() => handleOptionalClick(myOptional.idComponent)} />*/}
                                                        {/*</Tooltip>*/}
                                                        <img key={i} src={myOptional.urlThumb} className="w-optional" alt={myOptional.componentName} />
                                                    </div>
                                                    <div className="col-5 col-md-6 col-lg-5">
                                                        <p className="text-optional pb-3">{myOptional.componentName}</p>
                                                        {myOptional.idComponent !== myComponent.idComponent && <a className="optional-button" onClick={() => handleOptionalClick(myOptional.idComponent)}>{localizationCtx.localizationData.buttonSelect}</a>}
                                                        {myOptional.idComponent === myComponent.idComponent && <a className="optional-button-active">{localizationCtx.localizationData.buttonSelected} <CheckCircleOutlineRoundedIcon style={{ color: 'white' }} /></a>}
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div></div>
                    </div>
                </div>
            </Popover>
        </>
    );
};
export default Component;

